<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("blacklist report module settings") }}
      </h1>
    </div>

    <div class="title is-4">{{ $t("blacklist database configuration") }}</div>
    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("host") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="text" v-model="meta.blacklist_db_host" />
            <span class="icon is-small is-left">
              <i class="fa fa-server"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("port") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="text" v-model="meta.blacklist_db_port" />
            <span class="icon is-small is-left">
              <i class="fa fa-plug"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("database") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="text"
              v-model="meta.blacklist_db_database"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-database"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("username") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="text"
              v-model="meta.blacklist_db_username"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("password") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="password"
              v-model="meta.blacklist_db_password"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-lock"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('report generation script')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/script/catalog"
            name_field="name"
            value_field="directory"
            @selected="report_script_changed"
            ref="report_script_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("shared directory path") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.shared_directory_path"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("success endpoint url") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.success_endpoint_url"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("error endpoint url") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.error_endpoint_url"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="title is-5">{{ $t("signatures") }}</div>
    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('compliance officer signer')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/signer/catalog"
            name_field="name"
            value_field="signer_id"
            @selected="officer_signer_changed"
            ref="officer_signer_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="title is-5">{{ $t("logo") }}</div>
    <div class="columns">
      <div class="column is-5">
        <generic-dropdown
          :title="$t('drive')"
          :placeholder="$t('select one')"
          :is_multiple="false"
          url="/drive/catalog"
          name_field="name"
          value_field="drive_id"
          @selected="drive_changed"
          ref="drive_dropdown"
        />
      </div>
      <div class="column">
        <generic-uploader
          ref="generic_uploader"
          :idle_label="$t('drop logo image here')"
          endpoint_url="/blacklist-report/logo"
          :allow_multiple="false"
          @error="error_uploading"
          @success="success_uploading"
        />
        <figure class="image is-128x128 mt-5" v-if="meta.logo">
          <img
            :src="`${api_host}/drive/static/${meta.logo.final_name}`"
            :alt="meta.logo.original_name"
          />
        </figure>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  api_host,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "DictamenSettings",
  components: { GenericDropdown, GenericUploader },
  data() {
    return {
      meta: {},
      api_host,
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    officer_signer_changed(signer) {
      let v = this;
      if (signer) {
        v.meta.officer_signer_id = signer.signer_id;
      }
    },
    report_script_changed(script) {
      let v = this;
      if (script) {
        v.meta.report_script = script;
      }
    },
    drive_changed(drive) {
      let v = this;
      if (drive) {
        v.meta.drive_id = drive.drive_id;
      }
    },
    error_uploading(error) {
      console.error(error);
      error_message(error);
    },
    success_uploading(response) {
      let v = this;
      v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };

      v.meta.logo = data;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) v.meta = conf;

        if (v.meta.officer_signer_id)
          v.$refs.officer_signer_dropdown.set_value(v.meta.officer_signer_id);

        if (v.meta.report_script && v.meta.report_script.directory)
          v.$refs.report_script_dropdown.set_value(
            v.meta.report_script.directory
          );

        if (v.meta.drive_id) v.$refs.drive_dropdown.set_value(v.meta.drive_id);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
